import { render, staticRenderFns } from "./FoodIngredient.vue?vue&type=template&id=2bc685dc&scoped=true"
import script from "./FoodIngredient.vue?vue&type=script&lang=js"
export * from "./FoodIngredient.vue?vue&type=script&lang=js"
import style0 from "./FoodIngredient.vue?vue&type=style&index=0&id=2bc685dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc685dc",
  null
  
)

export default component.exports